"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 枚举类
 * Enum.IMAGE.name                => "图片"
 * Enum.getNameByKey('IMAGE')     => "图片"
 * Enum.getValueByKey('IMAGE')    => 10
 * Enum.getNameByValue(10)        => "图片"
 * Enum.getData()                 => [{key: "IMAGE", name: "图片", value: 10}]
 */
var Enum = /*#__PURE__*/function () {
  function Enum(param) {
    var _this = this;
    _classCallCheck(this, Enum);
    var keyArr = [];
    var valueArr = [];
    if (!Array.isArray(param)) {
      throw new Error('param is not an array!');
    }
    param.map(function (element) {
      if (!element.key || !element.name) {
        return;
      }
      // 保存key值组成的数组，方便A.getName(name)类型的调用
      keyArr.push(element.key);
      valueArr.push(element.value);
      // 根据key生成不同属性值，以便A.B.name类型的调用
      _this[element.key] = element;
      if (element.key !== element.value) {
        _this[element.value] = element;
      }
    });

    // 保存源数组
    this.data = param;
    this.keyArr = keyArr;
    this.valueArr = valueArr;

    // 防止被修改
    Object.freeze(this);
  }

  // 根据key得到对象
  return _createClass(Enum, [{
    key: "keyOf",
    value: function keyOf(key) {
      return this.data[this.keyArr.indexOf(key)];
    }

    // 根据key得到对象
  }, {
    key: "valueOf",
    value: function valueOf(key) {
      return this.data[this.valueArr.indexOf(key)];
    }

    // 根据key获取name值
  }, {
    key: "getNameByKey",
    value: function getNameByKey(key) {
      var prop = this.keyOf(key);
      if (!prop) {
        throw new Error('No enum constant' + key);
      }
      return prop.name;
    }

    // 根据value获取name值
  }, {
    key: "getNameByValue",
    value: function getNameByValue(value) {
      var prop = this.valueOf(value);
      if (!prop) {
        throw new Error('No enum constant' + value);
      }
      return prop.name;
    }

    // 根据key获取value值
  }, {
    key: "getValueByKey",
    value: function getValueByKey(key) {
      var prop = this.keyOf(key);
      if (!prop) {
        throw new Error('No enum constant' + key);
      }
      return prop.value;
    }

    // 返回源数组
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }]);
}();
var _default = exports.default = Enum;